import React from 'react';
import Modal2 from 'components/commons/modal/Modal2';
import { useRouting } from 'hooks/useRouting';

export const AccountRegisteringModal = ({
  isShowModal,
  hideModal,
}: {
  isShowModal: boolean;
  hideModal: () => void;
}) => {
  const routing = useRouting();
  const goSecurityaccounts = (): void => {
    routing.pushRouting({ path: `/securityaccounts` }, true);
  };

  return (
    <Modal2 isShow={isShowModal}>
      <div className="p-4 max-h-modal overflow-y-auto text-bluegray-700">
        <div className="flex flex-row">
          <div className="font-bold text-base">
            前回登録した口座を連携中です
          </div>
          <div
            className="icon-close ml-auto text-gray-500 cursor-pointer"
            onClick={hideModal}
          />
        </div>
        <div className="mt-4 text-sm">
          資産情報が反映されるまでしばらくお待ちください。
        </div>
        <div className="flex flex-col items-center">
          <button
            className="w-full justify-center mt-6 py-3 text-sm text-blue-700 bg-gray-50 border border-blue-700 rounded-lg"
            onClick={goSecurityaccounts}>
            口座一覧に戻る
          </button>
        </div>
      </div>
    </Modal2>
  );
};
